/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HasPaymentMethodResponse
 */
export interface HasPaymentMethodResponse {
    /**
     * 
     * @type {boolean}
     * @memberof HasPaymentMethodResponse
     */
    hasPaymentMethod: boolean;
}

/**
 * Check if a given object implements the HasPaymentMethodResponse interface.
 */
export function instanceOfHasPaymentMethodResponse(value: object): value is HasPaymentMethodResponse {
    if (!('hasPaymentMethod' in value) || value['hasPaymentMethod'] === undefined) return false;
    return true;
}

export function HasPaymentMethodResponseFromJSON(json: any): HasPaymentMethodResponse {
    return HasPaymentMethodResponseFromJSONTyped(json, false);
}

export function HasPaymentMethodResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HasPaymentMethodResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasPaymentMethod': json['hasPaymentMethod'],
    };
}

  export function HasPaymentMethodResponseToJSON(json: any): HasPaymentMethodResponse {
      return HasPaymentMethodResponseToJSONTyped(json, false);
  }

  export function HasPaymentMethodResponseToJSONTyped(value?: HasPaymentMethodResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasPaymentMethod': value['hasPaymentMethod'],
    };
}

